import { render, staticRenderFns } from "./AVCard.vue?vue&type=template&id=7b18c9a8&"
import script from "./AVCard.vue?vue&type=script&lang=js&"
export * from "./AVCard.vue?vue&type=script&lang=js&"
import style0 from "./AVCard.vue?vue&type=style&index=0&id=7b18c9a8&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports